jQuery(document).ready(function ($) {

    var dso_framework = (function () {

        var originalJs = function () {

            $('input, textarea').on('focus', function () {
                if ($(this).attr('placeholder')) $(this).data('placeholder', $(this).attr('placeholder')).removeAttr('placeholder');
            }).on('blur', function () {
                if ($(this).data('placeholder')) $(this).attr('placeholder', $(this).data('placeholder')).removeData('placeholder');
            });

            //Skip Link
            var skipLink = function () {
                $(".skiplink").focusin(function () {
                    $(this).css("position", "static");
                });

                $(".skiplink").focusout(function () {
                    $(this).css("position", "absolute");
                });
            }

            var youtube = document.querySelectorAll( ".video-frame" );

            for (var i = 0; i < youtube.length; i++) {
 
                // thumbnail image source.
                var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/hqdefault.jpg"; 

                // Load the image asynchronously
                var image = new Image();
                    image.src = source;
                    image.addEventListener( "load", function() {
                        youtube[ i ].appendChild( image );
                    }( i ) );

                youtube[i].addEventListener( "click", function() {
 
                var iframe = document.createElement( "iframe" );
         
                    iframe.setAttribute( "frameborder", "0" );
                    iframe.setAttribute( "allowfullscreen", "" );
                    iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );
         
                    this.innerHTML = "";
                    this.appendChild( iframe );
                } );
            }
        };
        /*
        var tableOfContents = function () {

            var ToC = '';

            var newLine, el, title, link;

            $(".toc-heading").each(function () {

                el = $(this);
                title = el.text();
                link = "#" + el.attr("id");

                newLine =
                    "<li>" +
                    "<a class='toc-link' href='" + link + "'>" +
                    title +
                    "</a>" +
                    "</li>";

                ToC += newLine;

            });

            $(".toc-table ul").prepend(ToC);

            $(".toc-link:empty").each(function () {
                $(this).parent().css({
                    display: 'none'
                });
            });

        };
        */
        //Apple Hover Menu Fix
        var hoverMenu = function () {

            function fnIsAppleMobile() {
                if (navigator && navigator.userAgent && navigator.userAgent != null) {
                    var strUserAgent = navigator.userAgent.toLowerCase();
                    var arrMatches = strUserAgent.match(/(iphone|ipod|ipad)/);
                    if (arrMatches != null)
                        return true;
                } // End if (navigator && navigator.userAgent)

                return false;
            } // End Function fnIsAppleMobile

            var bIsAppleMobile = fnIsAppleMobile();

            enquire.register("screen and (min-width: 992px)", {
                setup: function () {
                    // Load in content via AJAX (just the once)
                },
                match: function () {

                    if (!bIsAppleMobile) {

                        function toggleDropdown(e) {
                            const _d = $(e.target).closest('.dropdown'),
                                _m = $('.dropdown-menu', _d);
                            setTimeout(function () {
                                const shouldOpen = e.type !== 'click' && _d.is(':hover');
                                _m.toggleClass('show', shouldOpen);
                                _d.toggleClass('show', shouldOpen);
                                $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
                            }, e.type === 'mouseleave' ? 150 : 0);
                        }

                        $('body').on('mouseenter mouseleave', '.dropdown', toggleDropdown).on('click', '.dropdown-menu a', toggleDropdown);

                    }

                },
                unmatch: function () {

                }

            });

            enquire.register("screen and (max-width: 991px)", {
                setup: function () {
                    // Load in content via AJAX (just the once)
                },
                match: function () {

                    $('#nav-mobile .nav-link.dropdown-toggle').on('click', function () {
                        $(this).next().slideToggle();
                    });

                },
                unmatch: function () {

                }

            });

        };

        //Slick Slides
        var carousels = function () {

            $('.client-marketing-slider').slick({
              centerMode: true,
              //centerPadding: '60px',
              slidesToShow: 1,
              initialSlide: 1,
            });
        };

        return {

            init: function () {
                originalJs();
                //tableOfContents();
                hoverMenu();
                carousels();
            }

        }

    })();

    dso_framework.init();

});